import { render, staticRenderFns } from "./EventsKeyUp.vue?vue&type=template&id=1a6e035c&"
import script from "./EventsKeyUp.vue?vue&type=script&lang=js&"
export * from "./EventsKeyUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports